export const SupportTicketStatus = {
	ACTIVE: 1,
	PENDING: 2,
	CLOSED: 3,

	isOpen(status) {
		return status === SupportTicketStatus.ACTIVE || status === SupportTicketStatus.PENDING;
	},

	isClosed(status) {
		return status === SupportTicketStatus.CLOSED;
	},

	getLabel(status, t) {
		switch (status) {
			case SupportTicketStatus.ACTIVE:
				return t('pending');
			case SupportTicketStatus.PENDING:
				return t('active');
			case SupportTicketStatus.CLOSED:
				return t('closed');
			default:
				return t('unknown');
		}
	}
};
